import {Component, Input, OnInit} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'code-legend',
    templateUrl: './code-legend.component.html'
})
export class CodeLegendComponent implements OnInit {

    @Input() title: any;
    @Input() attendanceCodes: any;
    @Input() data: any;
    @Input() callbyAttendanceComponet = false;
    displayedColumns: string[] = ['code', 'description'];

    constructor(private dialogRef: MatDialogRef<CodeLegendComponent>, private dialog: MatDialogRef<CodeLegendComponent>) {
    }

    ngOnInit() {}

    closeClick() {
        this.dialog.close();
    }
}
